module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "AnswerText"
  }, [(_vm.content.text) ? _c('pre', {
    staticClass: "AnswerText-text",
    domProps: {
      "innerHTML": _vm._s(_vm.content.text)
    }
  }, [_vm._v("  ")]) : _vm._e(), _vm._v(" "), _c('img', {
    staticClass: "AnswerText-image",
    attrs: {
      "src": _vm.content.image
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-18bc6f90"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Learn/AnswerText.vue
// module id = 438
// module chunks = 1